import { DashletSettingsForm, DashletSettingsGroup, DashletSettingDropdown, DashletSettingCheckbox, DashletSettingDropdownGrouped, SelectItemGroup, SelectItem } from '@models/index';
import { DashletSettingsService } from '@services/index';

export class DashletSettingsFormCustomersByRegion extends DashletSettingsForm {
	constructor(private readonly settingsService: DashletSettingsService) {
		super();
	}

	loadState(obj: { [key: string]: object }): void {
		// super.loadState(obj);
	}
}
